import { history } from "redux/configureStore";
import { getQueryString } from "lib/routing";
import QueryString from "query-string";
import { filterObjByKeys } from "lib/utils";
import { ASSET_CLASSES } from "pages/redesign/header/desktop/DesktopHeaderParts/DesktopHeaderParts";

export const setAssetClass = (event, assetClass) => {
  if (!ASSET_CLASSES.includes(assetClass) && assetClass !== "Events") {
    return;
  }

  event.preventDefault();

  const qs = filterObjByKeys(getQueryString(), validParams);

  if (!["Equity", "Economics", "FX", "Rates", "Home"].includes(assetClass)) {
    delete qs.regions;
  }
  if (["Equity"].includes(assetClass)) {
    delete qs["currencies.en"];
    delete qs["currencies.jp"];
  }

  const normalizedAssetClass = assetClass === "SP/Credit" ? "SP__Credit" : assetClass;
  history.push(`/${normalizedAssetClass}?${QueryString.stringify(qs)}`);
};

// whitelist of query params which persist across asset classes (menu clicks)
const validParams = [
  "regions",
  "language",
  "Date",
  "analysts.name.en",
  "analysts.name.ja",
  "themes.en",
  "themes.ja",
  "regions.en",
  "regions.ja",
  "countries.en",
  "countries.ja",
  "contentType.en",
  "contentType.ja",
  "currencies.en",
  "currencies.jp",
];
